module.exports = {
  messages: {
    CN: {
      add: '添加',
      delete: '删除',
      save: '保存',
      cancel: '取消',
      edit: '编辑',
      deleteConfirm: '是否要删除此行？',
      newMember: '新增成员',
      table: {
        name: '成员姓名',
        number: '工号',
        department: '所属部门',
        operation: '操作',
      }
    },
    HK: {
      add: '添加',
      delete: '刪除',
      save: '保存',
      cancel: '取消',
      edit: '編輯',
      deleteConfirm: '是否要刪除此行？',
      newMember: '新增成員',
      table: {
        name: '成員姓名',
        number: '工號',
        department: '所屬部門',
        operation: '操作',
      }
    },
    US: {
      add: 'add',
      delete: 'delete',
      save: 'save',
      cancel: 'cancel',
      edit: 'edit',
      deleteConfirm: 'Confirm to delete this row?',
      newMember: 'new member',
      table: {
        name: 'Member Name',
        number: 'Job Number',
        department: 'Department',
        operation: 'Operation',
      }
    }
  }
}
